import { connect } from "react-redux";

var ReactTooltip = require("react-tooltip");

var StudentMetrics = require("lib/data/StudentMetrics");
var DataExportMetrics = require("lib/data/DataExportMetrics.js")
var Glyphicon = require("components/utility/icons/Glyphicon");
var BraveCheckbox = require("components/utility/BraveCheckbox");
var Spinner = require("components/utility/Spinner");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var CurrentUser = require("lib/account/CurrentUser");

require("data/exports/expanded_stats_selector.scss");

@connect(
    (state, props) => {
        // MOUNT STUDENT WITHIN STUDENT LISTS
        var studentLists = {}
        
        // filter student lists if selected a school org
        var filters = props.persistentData.selectedSchoolOrg ? { school_org_id: props.persistentData.selectedSchoolOrg.id } : {} 
        _.each(RosterSelectors.studentListsByAdminId({ state, adminId: CurrentUser.get().id, filters }), (sl) => {
            studentLists[sl.id] = sl
            studentLists[sl.id].students = []
            studentLists[sl.id].primary_students = []
        })

        _.each(state.students, (student) => {
            if (student.student_list_ids) {
                _.each(student.student_list_ids.all, (id) => {
                    if (studentLists[id]) {
                        studentLists[id].students.push(student)
                    }
                })
                if (studentLists[student.student_list_ids.primary]) {
                    studentLists[student.student_list_ids.primary].primary_students.push(student)
                }
            }
        })

        var loading = RosterSelectors.isLoadingStudentLists({ state })

        return {
            studentLists: _.values(studentLists),
            loading,
        }
    }
)

class ExpandableStatsSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedCategories: [],
            selectedMetrics: [],
            selectedMetricCategory: null,
            selectedOrganizationType: null,
        };
    }

    ///// HELPERS /////
    renderErrorAlert(text) {
        window.wrNotifications.triggerDropDownNotification({
            text: text,
            icon: "exclamation-sign", type: "error"
        }, 3000);
    }

    selectedAddtionalMetrics() {
        var { selectedMetricCategory } = this.state
        return selectedMetricCategory == DataExportMetrics.ADDITIONAL_METRICS
    }

    selectedGoalMetrics() {
        var { selectedMetricCategory } = this.state
        return selectedMetricCategory == DataExportMetrics.GOALS
    }

    selectedRosterMetrics() {
        var { selectedMetricCategory } = this.state
        return selectedMetricCategory == DataExportMetrics.ROSTER
    }

    // returns unique list of goal metrics from all student lists
    extractGoalMetrics() {
        var goalMetrics = []
        _.each(_.pluck(this.props.studentLists, 'prefs'), prefs => {
            var glGoals = prefs.grade_level_expectations_metrics
            for (var g in prefs.grade_level_expectations_metrics) {
                var goalKeys = _.pluck(glGoals[g], 'metric')
                _.each(goalKeys, gk => {
                    var goalConfig = _.findWhere(DataExportMetrics.METRICS_BY_CATEGORY['goals'], { key: gk })
                    if (goalConfig) {
                        goalMetrics = _.uniq([...goalMetrics, goalConfig])
                    }
                })
            }
        })
        return _.compact(goalMetrics)
    }

    retreatePossible() {
        var { track } = this.props
        return _.indexOf(track, _.findWhere(track, { name: 'metric-selector' })) > 0
    }

    ///// VALIDATORS /////
    validSelectedMetrics() {
        return !_.isEmpty(this.state.selectedMetrics)
    }

    validOrganizationType(selectedOrganizationType) {
        var { organizationOptions } = this.props
        return _.includes(_.pluck(organizationOptions, 'key'), selectedOrganizationType)
    }

    ///// HANDLERS /////
    // toggles metric set selection
    handleMetricCategoryToggle(label) {
        var { expandedCategories } = this.state;
        if (expandedCategories.includes(label)) {
            expandedCategories.splice(expandedCategories.indexOf(label), 1);
        } else {
            expandedCategories.push(label);
        }
        this.setState({ expandedCategories });
    }

    // toggles metric selection
    handleMetricSelection(metric) {
        var { selectedMetrics } = this.state
        if (selectedMetrics.includes(metric)) {
            selectedMetrics.splice(selectedMetrics.indexOf(metric), 1);
        } else {
            selectedMetrics.push(metric);
        }

        this.setState({ selectedMetrics })
    }

    handleCategoryChange(selectedMetricCategory) {
        var { selectedOrganizationType } = this.state
        var selectedMetrics = []
        var expandedCategories = []
        this.setState({ selectedMetricCategory, selectedMetrics, expandedCategories }, () => {
            if (this.selectedGoalMetrics()) { 
                // preselect all goals
                selectedMetrics = _.pluck(this.extractGoalMetrics(), 'key')
                this.setState({ selectedMetrics })
            } else if (!this.selectedAddtionalMetrics()) {
                // preselect all metrics within a category
                selectedMetrics = _.pluck(DataExportMetrics.METRICS_BY_CATEGORY[selectedMetricCategory], 'key')
                this.setState({ selectedMetrics })

                // restrict user from using chrono xls organization type when roster category is selected
                if (this.selectedRosterMetrics() && selectedOrganizationType == DataExportMetrics.CHRONO) {
                    this.setState({ selectedOrganizationType: DataExportMetrics.PER_CLASS })
                }
            }
        })
    }

    handleOrganizationTypeChange(selectedOrganizationType) {
        this.setState({ selectedOrganizationType })
    }

    handleRetreatStage() {
        var { selectedMetrics, selectedMetricCategory, selectedOrganizationType } = this.state
        this.props.onRetreat({ selectedMetrics, selectedMetricCategory, selectedOrganizationType })
    }

    ///// SUBMIT /////
    onSubmit() {
        var { selectedMetrics, selectedMetricCategory, selectedOrganizationType } = this.state
        if (!this.validSelectedMetrics()) {
            this.renderErrorAlert("Please Select Metrics")
        } else if (!this.validOrganizationType(selectedOrganizationType)) {
            this.renderErrorAlert("Please Select How You'd Like The Data Organized")
        } else {
            this.props.onComplete({ selectedMetrics, selectedMetricCategory, selectedOrganizationType })
        }
    }

    ///// RENDER METHODS /////

    // special rendering for goal metrics
    // we need to aggregate all goals from all student lists
    // add a loader if the student lists are still loading
    renderGoalMetricsSelector() {
        var { selectedMetrics, selectedMetricCategory } = this.state;
        var goalMetrics = this.extractGoalMetrics()

        if (this.props.loading) {
            goalMetrics = <Spinner placeholder={true} scale={1.7} />
        } else {            
            goalMetrics = (
                <div className="dropdownSelector__metricCategoryName">
                    <div className='metricCategoryTitle' onClick={() => this.handleMetricCategoryToggle(selectedMetricCategory)}>
                        {$wr.toTitleCase(selectedMetricCategory.replace('_', ' '))}
                    </div>
                    <div className="dropdownSelector__metrics">
                        {goalMetrics.map((metricConfig, j) => (
                            <div key={j} className="dropdownSelector__metricsContainer">
                                <BraveCheckbox
                                    onClick={() => this.handleMetricSelection(metricConfig.key)}
                                    value={selectedMetrics.includes(metricConfig.key)}
                                />
                                <div className='metricLabel'>{metricConfig.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )
        }

        return (
            <div className="dropdownSelector">
                <div className="dropdownSelector__dropdown">
                    {goalMetrics}
                </div>
            </div>
        )
    }

    // expandable metric selector, each category has children
    renderExpandableSelector() {
        var { expandedCategories, selectedMetrics, selectedMetricCategory } = this.state;

        return (
            <div className="dropdownSelector">
                <div className="dropdownSelector__dropdown">
                    {DataExportMetrics.METRICS_BY_CATEGORY[selectedMetricCategory].map((cat, i) => (
                        <div key={i} className="dropdownSelector__metricCategoryName">
                            <div className='metricCategoryTitle' onClick={() => this.handleMetricCategoryToggle(cat.label)}>
                                {cat.label}
                            </div>
                            {expandedCategories.includes(cat.label) && (
                                <div className="dropdownSelector__metrics">
                                    {cat.children.map((metricKey, j) => (
                                        <div key={j} className="dropdownSelector__metricsContainer">
                                            <BraveCheckbox
                                                onClick={() => this.handleMetricSelection(metricKey)}
                                                value={selectedMetrics.includes(metricKey)}
                                            />                                            
                                            <div className='metricLabel'>{StudentMetrics.getLabel(metricKey)}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    // basic metric selector, takes array from DataExportMetrics.METRICS_BY_CATEGORY
    renderMetricsSelector() {
        var { selectedMetrics, selectedMetricCategory } = this.state;
        return (
            <div className="dropdownSelector">
                <div className="dropdownSelector__dropdown">
                    <div className="dropdownSelector__metricCategoryName">
                        <div className='metricCategoryTitle' onClick={() => this.handleMetricCategoryToggle(selectedMetricCategory)}>
                            {$wr.toTitleCase(selectedMetricCategory.replace('_', ' '))}
                        </div>
                        <div className="dropdownSelector__metrics">
                            {DataExportMetrics.METRICS_BY_CATEGORY[selectedMetricCategory].map((metricConfig, j) => (
                                <div key={j} className="dropdownSelector__metricsContainer">
                                    <BraveCheckbox
                                        onClick={() => this.handleMetricSelection(metricConfig.key)}
                                        value={selectedMetrics.includes(metricConfig.key)}
                                    />
                                    <div className='metricLabel'>{metricConfig.label}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderCategoryMetrics() {
        var { selectedMetricCategory } = this.state

        if (selectedMetricCategory == null || selectedMetricCategory == 'none') { return null }
        
        if (this.selectedAddtionalMetrics()) {
            return this.renderExpandableSelector()
        } else if (this.selectedGoalMetrics()) { 
            return this.renderGoalMetricsSelector()
        } else {
            return this.renderMetricsSelector()
        }
    }

    renderCategorySelector() {
        return (
            <div className="selectContainer">
                <select value={this.state.selectedMetricCategory || ''} onChange={e => this.handleCategoryChange(e.target.value)} className="selectElement">
                    {_.keys(DataExportMetrics.METRICS_BY_CATEGORY).map(m => (
                        <option value={m} key={m}>{$wr.toTitleCase(m.replace('_', ' '))}</option>
                    ))}
                </select>
            </div>
        )
    }

    renderOrganizationSelector() {
        var { organizationOptions } = this.props
        var { selectedMetricCategory } = this.state
        
        // filter out chrono option when pulling roster data
        if (selectedMetricCategory == DataExportMetrics.ROSTER) {
            organizationOptions = _.filter(organizationOptions, op => { return op.key !== DataExportMetrics.CHRONO })
        }

        return (
            <div className="selectContainer">
                <select value={this.state.selectedOrganizationType || ''} onChange={e => this.handleOrganizationTypeChange(e.target.value)} className="selectElement">
                    {organizationOptions.map(c => (
                        <option value={c.key} key={c.key}>{c.label}</option>
                    ))}
                </select>
            </div>
        )
    }

    renderInfoTooltip(dataTip) {
        return (
            <span>
                <Glyphicon icon="info-sign" className="infoSign" dataTip={dataTip} />
                <ReactTooltip effect="solid" />
            </span>
        )        
    }

    renderStatsSelector() {
        var { selectedMetricCategory } = this.state

        return (
            <div>
                <div className="selectorsContainer">
                    <div>
                        <div className="selectorTitle">
                            Select a Metric Set {this.renderInfoTooltip(METRIC_SET_TOOLTIP)}
                        </div>
                        <div className="selector">
                            {this.renderCategorySelector()}
                        </div>
                    </div>
                    <div>
                        <div className="selectorTitle">
                            Organize Excel Sheets {this.renderInfoTooltip(CSV_ORGANIZATION_TOOLTIP)}
                        </div>
                        <div className="selector">
                            {this.renderOrganizationSelector()}
                        </div>
                    </div>
                </div>
                {selectedMetricCategory && (
                    this.renderCategoryMetrics()
                )}
            </div>
        )
    }

    render() {
        return (
            <div className="metricsDropdownSelectorContainer">
                {this.renderStatsSelector()}
                <div className="onSubmitContainer">
                    {this.retreatePossible() && (
                        <button className='backBtn' onClick={() => this.handleRetreatStage()}>Back</button>
                    )}
                    {this.validSelectedMetrics() && (
                        <button className='nextBtn' onClick={() => this.onSubmit()}>Next</button>
                    )}
                </div>
            </div>
        );
    }

    componentDidMount() {
        var { persistentData, organizationOptions } = this.props
        // preselect metric set and xls organization type if already exists in persistent data
        var selectedMetricCategory = _.has(persistentData, 'selectedMetricCategory') ? persistentData.selectedMetricCategory : DataExportMetrics.QUIZZES
        var selectedOrganizationType = _.has(persistentData, 'selectedOrganizationType') ? persistentData.selectedOrganizationType : organizationOptions[0].key        
        this.handleCategoryChange(selectedMetricCategory)
        this.handleOrganizationTypeChange(selectedOrganizationType)
    }
}

ExpandableStatsSelector.propTypes = StrictPropTypes({
    endOnboarding: PropTypes.func,
    handleAdvanceStage: PropTypes.func,
    onSubmit: PropTypes.func,
    onComplete: PropTypes.func,
    onRetreat: PropTypes.func,
    track: PropTypes.array,
    persistentData: PropTypes.object,
    currentAdmin: PropTypes.object,
    organizationOptions: PropTypes.array,
    handlePrint: PropTypes.func,
});

var CSV_ORGANIZATION_TOOLTIP = "Organize your Excel sheets to fit your needs. Sort metrics by students or by classes, or see data chronologically by date."
var METRIC_SET_TOOLTIP = 'Select a data metric category, then specify individual metrics within that category to tailor the data export to display exactly what you need.'

module.exports = ExpandableStatsSelector;


// WEBPACK FOOTER //
// ./modules/components/data/exports/ExpandableStatsSelector.js